import Vue from 'vue';
import { f7 } from "framework7-vue";
import MathLive from 'mathlive';
import CONST from './constant';


var MODULE = {};

MODULE.EventBus = new Vue();

MODULE.Ajax = {
	request: function (param) {

		var def = jQuery.Deferred();

		// param = {url:"", data:{}, type:""}

		var ajaxObject = {};
		ajaxObject.url = param.url;
		ajaxObject.data = param.data || "";
		ajaxObject.type = param.type || "POST";
		ajaxObject.dataType = "json";
		ajaxObject.beforeSend = function (xhr) {
			xhr.setRequestHeader("Accept", "application/json");
		};
		ajaxObject.success = function (data, textStatus, responseObject) {
			var jsonObject = responseObject.responseJSON;
			var resultCode = jsonObject.code;
			var resultValue = jsonObject.value;

			if (resultCode == "OK") {
				def.resolve(resultValue);
			} else {
				return def.reject(resultCode).promise();
			}
		};
		ajaxObject.error = function (jqXHR, exception) {
			if (jqXHR.status === 0) {
				return def.reject("NETWORK-ERROR").promise();
			} else if (jqXHR.status == 404) {
				return def.reject("404-ERROR").promise();
			} else if (jqXHR.status == 500) {
				return def.reject("500-ERROR").promise();
			} else if (exception === 'parsererror') {
				return def.reject("PARSER-ERROR").promise();
			} else if (exception === 'timeout') {
				msg = 'Time out error.';
				return def.reject("TIMEOUT-ERROR").promise();
			} else if (exception === 'abort') {
				msg = 'Ajax request aborted.';
				return def.reject("ABORTED-ERROR").promise();
			}

			return def.reject("ERROR").promise();
		}

		$.ajax(ajaxObject);

		return def.promise();
	},
}

MODULE.JsonRequest = {
	request: function (param) {

		var def = jQuery.Deferred();

		// param = {url:"", data:{}, type:""}

		var ajaxObject = {};
		ajaxObject.url = param.url;
		ajaxObject.data = param.data || "";
		ajaxObject.type = param.type || "POST";
		ajaxObject.contentType = "application/json";
		ajaxObject.dataType = "json";
		ajaxObject.beforeSend = function (xhr) {
			xhr.setRequestHeader("Accept", "application/json");
		};
		ajaxObject.success = function (data, textStatus, responseObject) {
			var jsonObject = responseObject.responseJSON;
			var resultCode = jsonObject.code;
			var resultValue = jsonObject.value;

			if (resultCode == "OK") {
				def.resolve(resultValue);
			} else {
				return def.reject(resultCode).promise();
			}
		};
		ajaxObject.error = function (jqXHR, exception) {
			if (jqXHR.status === 0) {
				return def.reject("NETWORK-ERROR").promise();
			} else if (jqXHR.status == 404) {
				return def.reject("404-ERROR").promise();
			} else if (jqXHR.status == 500) {
				return def.reject("500-ERROR").promise();
			} else if (exception === 'parsererror') {
				return def.reject("PARSER-ERROR").promise();
			} else if (exception === 'timeout') {
				msg = 'Time out error.';
				return def.reject("TIMEOUT-ERROR").promise();
			} else if (exception === 'abort') {
				msg = 'Ajax request aborted.';
				return def.reject("ABORTED-ERROR").promise();
			}

			return def.reject("ERROR").promise();
		}

		$.ajax(ajaxObject);

		return def.promise();
	},
}

MODULE.Util = {
	isChromeBrowser() {
		var userAgent = window.navigator.userAgent;
		var isChrome = userAgent.indexOf('Chrome');
		var isChromeMobile = userAgent.indexOf('CriOS');
		var isSamsungBrowser = userAgent.indexOf('SamsungBrowser');
		var isWindows = userAgent.indexOf('Windows NT');
		var isEdge = userAgent.indexOf('Edge');
		var isIE = userAgent.indexOf('Trident');

		if (isChrome > -1 || isChromeMobile > -1) {
			if (isSamsungBrowser < 0 && isEdge < 0) {
				return true;
			}
		}

		return false;
	},
	getOSName() {
		var agent = navigator.userAgent.toLowerCase();
		if (agent.indexOf("windows nt") >= 0)
			return "Windows";
		else if (agent.indexOf("windows phone") >= 0)
			return "Windows Phone";
		else if (agent.indexOf("android") >= 0)
			return "Android";
		else if (agent.indexOf("iphone") >= 0)
			return "IPhone";
		else if (agent.indexOf("ipad") >= 0)
			return "IPad";
		else if (agent.indexOf("ipod") >= 0)
			return "IPod";
		else if (agent.indexOf("mac") >= 0)
			return "Mac";
		else
			return "etc";
	},
	timediff(timestamp) {
		var now = moment(new Date());
		var theDate = moment(timestamp);
		var duration = moment.duration(theDate.diff(now));

		var years = parseInt(duration.asYears());
		if (years < 0) {
			return Math.abs(years) + "년전";
		} else if (years > 0) {
			return years + "년후";
		}

		var months = parseInt(duration.asMonths());
		if (months < 0) {
			return Math.abs(months) + "개월전";
		} else if (months > 0) {
			return months + "개월후";
		}

		var weeks = parseInt(duration.asWeeks());
		if (weeks < 0) {
			return Math.abs(weeks) + "주전";
		} else if (weeks > 0) {
			return weeks + "주후";
		}

		var days = parseInt(duration.asDays());
		if (days < 0) {
			return Math.abs(days) + "일전";
		} else if (days > 0) {
			return days + "일후";
		}

		var hours = parseInt(duration.asHours());
		if (hours < 0) {
			return Math.abs(hours) + "시간전";
		} else if (hours > 0) {
			return hours + "시간후";
		}

		var minutes = parseInt(duration.asMinutes());
		if (minutes < 0) {
			return Math.abs(minutes) + "분전";
		} else if (minutes > 0) {
			return minutes + "분후";
		}

		var seconds = parseInt(duration.asSeconds());
		if (seconds < 0) {
			return "방금전";
		} else if (seconds > 0) {
			return "조금후";
		}

		return "지금";
	},
	datediff(timestamp) {
		var now = moment({ h: 0, m: 0, s: 0, ms: 0 });
		var _theDate = moment(timestamp);
		var theDate = moment({
			year: _theDate.year(),
			month: _theDate.month(),
			day: _theDate.date()
		});

		var duration = moment.duration(theDate.diff(now));

		var years = parseInt(duration.years());
		if (years < 0) {
			return Math.abs(years) + "년전";
		} else if (years > 0) {
			return years + "년후";
		}

		var months = parseInt(duration.months());
		if (months < 0) {
			return Math.abs(months) + "개월전";
		} else if (months > 0) {
			return months + "개월후";
		}

		var weeks = parseInt(duration.weeks());
		if (weeks < 0) {
			return Math.abs(weeks) + "주전";
		} else if (weeks > 0) {
			return weeks + "주후";
		}

		var days = parseInt(duration.days());
		if (days < -2) {
			return Math.abs(days) + "일전";
		} else if (days == -2) {
			return "그저께";
		} else if (days == -1) {
			return "어제";
		} else if (days == 0) {
			return "오늘";
		} else if (days == 1) {
			return "내일";
		} else if (days == 2) {
			return "모레";
		} else if (days > 2) {
			return days + "일후";
		}

		return "";
	},
	appCall: function() {
		var url = "otmathon://";

		var accessToken = arguments[0];
		var cmd = arguments[1];

		url = url + cmd + "?" + 
			"at=" + accessToken;

		var name = "";
		var value = "";

		for (var i=2; i<arguments.length; i++) {
			var arg = arguments[i];
			
			if (MODULE.Util.isEmpty(name)) {
				name = arg;
			} else {
				value = arg;

				url = url + "&" + name + "=" + value;

				name = "";
				value = "";
			}
		}
		
		window.open(url, "_system");
	},
	codePrefix: function(code) {
		if (MODULE.Util.isEmpty(code)) {
			return "";
		}

		var prefix = code.substring(0, 1);

		if (prefix == CONST.linkExamCodePrefix) {
			return CONST.linkExamCodePrefix;
		} else if (prefix == CONST.examSetCodePrefix) {
			return CONST.examSetCodePrefix;
		} else if (prefix == CONST.lectureCodePrefix) {
			return CONST.lectureCodePrefix;
		} else if (prefix == CONST.matchPaperCodePrefix) {
			return CONST.matchPaperCodePrefix;
		} else if (prefix == CONST.matchBookCodePrefix) {
			return CONST.matchBookCodePrefix;
		} else if (prefix == CONST.smartBookCodePrefix) {
			return CONST.smartBookCodePrefix;
		} else if (prefix == CONST.pqatCodePrefix) {
			return CONST.pqatCodePrefix;
		} else {
			return "";
		}
	},
	codeToKey: function(prefix, code) {
		if (MODULE.Util.isEmpty(code)) {
			return -1;
		}

		if (! code.startsWith(prefix)) {
			return -2;
		}

		var keyPart = code.substring(1);

		if (MODULE.Util.isEmpty(keyPart)) {
			return -3;
		}

		if (keyPart.startsWith("@")) {
			// @를 붙이면 십진수로 인식 ex) E@123 -> examSetKey = 123
			keyPart = keyPart.substring(1);
			if (MODULE.Util.isEmpty(keyPart)) {
				return -4;
			}

			if (MODULE.Util.number(keyPart) != keyPart) {
				return -5;
			}

			var key = keyPart;
			return key;
		}

		try {
			var key = MODULE.Util.d32Tod10(keyPart);
			return key;
		}
		catch (e) {
			return -10;
		}
	},
	keyToCode: function(prefix, key) {
		return prefix + MODULE.Util.d10Tod32(key);
	},
	codeToSubPath: function(prefix, code, postfix) {
		var key = MODULE.Util.codeToKey(prefix, code);

		if (key <= 0) {
			MODULE.DialogBox.message("에러", "잘못된 코드입니다.<br/>코드를 확인하세요.");
			return "";
		}

		var _ret = key;
		var _mod = 0;

		_mod = _ret % 1000000;
		_ret = Math.trunc(_ret / 1000000);
		var d6 = MODULE.Util.sprintf("%03d", _ret);
		_ret = _mod;

		_mod = _ret % 10000;
    _ret = Math.trunc(_ret / 10000);
    var d4 = MODULE.Util.sprintf("%02d", _ret);
    _ret = _mod;
		
		_mod = _ret % 100;
    _ret = Math.trunc(_ret / 100);
    var d2 = MODULE.Util.sprintf("%02d", _ret);
		_ret = _mod;
		
		var keyPart = MODULE.Util.sprintf("%d", key);
		
		return "d6-" + d6 + "/d4-" + d4 + "/d2-" + d2 + "/" + postfix + keyPart;
	},
	codeToFileName: function(prefix, code, postfix) {
		var key = MODULE.Util.codeToKey(prefix, code);

		if (key <= 0) {
			MODULE.DialogBox.message("에러", "잘못된 코드입니다.<br/>코드를 확인하세요.");
			return "";
		}

		var keyPart = MODULE.Util.sprintf("%d", key);

		return keyPart + postfix;
	},
	getVarChar2Bytes: function(str) {
		var b = 0;
		var c = undefined;

		for (var i = 0; i < str.length; i++) {
			c = str.charCodeAt(i);
			b += (c >> 11 ? 3 : c >> 7 ? 2 : 1);
		}

		return b;
	},
	sortedArrayPush: function(array, item, key) {
		var pushed = false;
		for (var i=0; i<array.length; i++) {
			var _item = array[i];

			if (_item[key] > item[key]) {
				array.splice(i, 0, item);
				pushed = true;
				break;
			}
		}

		if (! pushed) {
			array.push(item);
		}
	},
	JsonStrToObject: function(jsonStr) {
		return JSON.parse(jsonStr);
	},
	ObjectToJsonStr: function(obj) {
		return JSON.stringify(obj);
	},
	arrayToMap: function(array, key) {
		var map = new Map();

		for (var i = 0; i < array.length; i++) {
			var _item = array[i];

			map.set(_item[key], _item);
		}

		return map;
	},
	compareTwoArrays: function(param) {
		/*
		배열1, 배열2는 조건키값으로 오름차순 정렬되있어야 한다.
		param = {
			array1: array,		// 배열1
			array2: array,		// 배열2
			a1CaseKey: "",		// 배열1 필터 조건키
			a1CaseValue: "",	// 배열1 필터 조건값
			a2CaseKey: "",		// 배열2 필터 조건키
			a2CaseValue: "",	// 배열2 필터 조건값
			a1CompareKey: "",	// 배열 비교키(배열1)
			a2CompareKey: "",	// 배열 비교키(배열2)
			equalFunc: function(a1Index, a1Item, a2Index, a2Item) {}
		}
		*/

		for (var a1Index = 0; a1Index < param.array1.length; a1Index++) {
			var a1Item = param.array1[a1Index];

			if (param.a1CaseKey != undefined) {
				if (a1Item[param.a1CaseKey] != param.a1CaseValue) {
					continue;
				}
			}

			for (var a2Index = 0; a2Index < param.array2.length; a2Index++) {
				var a2Item = param.array2[a2Index];

				if (param.a2CaseKey != undefined) {
					if (a2Item[param.a2CaseKey] != param.a2CaseValue) {
						continue;
					}
				}

				if (a1Item[param.a1CompareKey] == a2Item[param.a2CompareKey]) {
					param.equalFunc(a1Index, a1Item, a2Index, a2Item);
					break;
				}
			}
		}
	},
	isEmpty: function(value) {
		if (value === undefined)
			return true;

		if (typeof (value) == 'function' || typeof (value) == 'number' || typeof (value) == 'boolean' || Object.prototype.toString.call(value) === '[object Date]')
			return false;

		if (typeof (value) == 'string' && (value == "" || value == "-")) 
			return true;

		if (value == null || value.length === 0)        // null or 0 length array
			return true;

		if (jQuery.isEmptyObject(value)) 
			return true;

		return false;
	},
	isNotEmpty: function(value) {
		var _this = this;

		return !_this.isEmpty(value);
	},
	isInGroupValue: function (findValue, groupValue) {
		var values = MODULE.Util.splitGroupValue(groupValue);
		for (var i = 0; i < values.length; i++) {
			var value = values[i];

			if (value == findValue) {
				return true;
			}
		}

		return false;
	},
	sortArrayByArray: function(array, baseArray) {
		var _array = JSON.parse(JSON.stringify(array));
		var result = [];

		for (var i=0; i<baseArray.length; i++) {
			var baseItem = baseArray[i];

			for (var j = 0; j < _array.length; j++) {
				var item = _array[j];

				if (baseItem == item) {
					result.push(item);
					MODULE.Util.removeItem(_array, j);
					break;
				}
			}

			if (_array.length == 0) {
				break;
			}
		}

		return result;
	},
	clearArray: function(array) {
		array.splice(0, array.length);
		return array;
	},
	splitGroupValue: function(value) {
		var values = [];

		var groupValue = String(value);
		if (MODULE.Util.isNotEmpty(groupValue)) {
			groupValue = groupValue.replace(/\.\.+/g, '.');
			values = groupValue.split(".");
		}

		return values;
	},
	mergeGroupValue: function(values)  {
		var groupValue = "";

		if (values != undefined && values != null && values.length > 0) {
			for (var i = 0; i < values.length; i++) {
				var value = values[i];

				if (MODULE.Util.isNotEmpty(value)) {
					if (i > 0) {
						groupValue = groupValue + ".";
					}

					groupValue = groupValue + value;
				}
			}
		}

		return groupValue;
	},
	removeItem: function(array, index) {
		array.splice(index, 1);
		return array;
	},
	toBoolean: function(str) {
		if (str == undefined || str == "") {
			return false;
		}

		var _str = str.toLowerCase();

		if (_str == "true") {
			return true;
		} else if (_str == "false") {
			return false;
		} else {
			return false;
		}
	},
	leftZeroPad: function (number, targetLength) {
		var output = number + '';
		while (output.length < targetLength) {
			output = '0' + output;
		}
		return output;
	},
	sprintf: function() {
		var regex = /%%|%(\d+\$)?([-+#0 ]*)(\*\d+\$|\*|\d+)?(\.(\*\d+\$|\*|\d+))?([scboxXuidfegpEGP])/g;
		
		function pad(str, len, chr, leftJustify) {
			var padding = (str.length >= len) ? '' : Array(1 + len - str.length >>> 0).join(chr);
			return leftJustify ? str + padding : padding + str;
		}

		function justify(value, prefix, leftJustify, minWidth, zeroPad) {
			var diff = minWidth - value.length;
			if (diff > 0) {
				if (leftJustify || !zeroPad) {
					value = pad(value, minWidth, ' ', leftJustify);
				} else {
					value = value.slice(0, prefix.length) + pad('', diff, '0', true) + value.slice(prefix.length);
				}
			}
			return value;
		}

		var a = arguments, i = 0, format = a[i++];
		return format.replace(regex, function (substring, valueIndex, flags, minWidth, _, precision, type) {
			if (substring == '%%') return '%';

			// parse flags
			var leftJustify = false, positivePrefix = '', zeroPad = false, prefixBaseX = false;
			for (var j = 0; flags && j < flags.length; j++) switch (flags.charAt(j)) {
				case ' ': positivePrefix = ' '; break;
				case '+': positivePrefix = '+'; break;
				case '-': leftJustify = true; break;
				case '0': zeroPad = true; break;
				case '#': prefixBaseX = true; break;
			}

			// parameters may be null, undefined, empty-string or real valued
			// we want to ignore null, undefined and empty-string values

			if (!minWidth) {
				minWidth = 0;
			} else if (minWidth == '*') {
				minWidth = +a[i++];
			} else if (minWidth.charAt(0) == '*') {
				minWidth = +a[minWidth.slice(1, -1)];
			} else {
				minWidth = +minWidth;
			}

			// Note: undocumented perl feature:
			if (minWidth < 0) {
				minWidth = -minWidth;
				leftJustify = true;
			}

			if (!isFinite(minWidth)) {
				throw new Error('sprintf: (minimum-)width must be finite');
			}

			if (precision && precision.charAt(0) == '*') {
				precision = +a[(precision == '*') ? i++ : precision.slice(1, -1)];
				if (precision < 0) {
					precision = null;
				}
			}

			if (precision == null) {
				precision = 'fFeE'.indexOf(type) > -1 ? 6 : (type == 'd') ? 0 : void (0);
			} else {
				precision = +precision;
			}

			// grab value using valueIndex if required?
			var value = valueIndex ? a[valueIndex.slice(0, -1)] : a[i++];
			var prefix, base;

			switch (type) {
				case 'c': value = String.fromCharCode(+value);
				case 's': {
					// If you'd rather treat nulls as empty-strings, uncomment next line:
					// if (value == null) return '';

					value = String(value);
					if (precision != null) {
						value = value.slice(0, precision);
					}
					prefix = '';
					break;
				}
				case 'b': base = 2; break;
				case 'o': base = 8; break;
				case 'u': base = 10; break;
				case 'x': case 'X': base = 16; break;
				case 'i':
				case 'd': {
					var number = parseInt(+value);
					if (isNaN(number)) {
						return '';
					}
					prefix = number < 0 ? '-' : positivePrefix;
					value = prefix + pad(String(Math.abs(number)), precision, '0', false);
					break;
				}
				case 'e': case 'E':
				case 'f': case 'F':
				case 'g': case 'G':
				case 'p': case 'P':
					{
						var number = +value;
						if (isNaN(number)) {
							return '';
						}
						prefix = number < 0 ? '-' : positivePrefix;
						var method;
						if ('p' != type.toLowerCase()) {
							method = ['toExponential', 'toFixed', 'toPrecision']['efg'.indexOf(type.toLowerCase())];
						} else {
							// Count significant-figures, taking special-care of zeroes ('0' vs '0.00' etc.)
							var sf = String(value).replace(/[eE].*|[^\d]/g, '');
							sf = (number ? sf.replace(/^0+/, '') : sf).length;
							precision = precision ? Math.min(precision, sf) : precision;
							method = (!precision || precision <= sf) ? 'toPrecision' : 'toExponential';
						}
						var number_str = Math.abs(number)[method](precision);
						// number_str = thousandSeparation ? thousand_separate(number_str): number_str;
						value = prefix + number_str;
						break;
					}
				case 'n': return '';
				default: return substring;
			}

			if (base) {
				// cast to non-negative integer:
				var number = value >>> 0;
				prefix = prefixBaseX && base != 10 && number && ['0b', '0', '0x'][base >> 3] || '';
				value = prefix + pad(number.toString(base), precision || 0, '0', false);
			}
			var justified = justify(value, prefix, leftJustify, minWidth, zeroPad);
			return ('EFGPX'.indexOf(type) > -1) ? justified.toUpperCase() : justified;
		});
	},
	getMatchBookImagePath: function(bookImageNo) {
		var nBookImageNo = MODULE.Util.number(bookImageNo);

		var d4 = Math.floor(nBookImageNo / 10000);
		var d4Str = "d4-" + MODULE.Util.sprintf("%02d", d4);
		nBookImageNo = nBookImageNo % 10000;

		var d2 = Math.floor(nBookImageNo / 100);
		var d2Str = "d2-" + MODULE.Util.sprintf("%02d", d2);
		nBookImageNo = nBookImageNo % 100;

		var bi = "bi-" + bookImageNo;

		return CONST.contentServerUrl + "/websvr/contents/common/matchbookimage/" + d4Str + "/" + d2Str + "/" + bi;
	},
	getMatchBookImageUrl: function (bookImageNo) {
		var bookImagePath = MODULE.Util.getMatchBookImagePath(bookImageNo);
		var bookImageUrl = bookImagePath + "/" + bookImageNo + "-bookimage.png";

		return bookImageUrl;
	},
	getSmartBookImagePath: function(bookImageNo) {
		var nBookImageNo = MODULE.Util.number(bookImageNo);

		var d4 = Math.floor(nBookImageNo / 10000);
		var d4Str = "d4-" + MODULE.Util.sprintf("%02d", d4);
		nBookImageNo = nBookImageNo % 10000;

		var d2 = Math.floor(nBookImageNo / 100);
		var d2Str = "d2-" + MODULE.Util.sprintf("%02d", d2);
		nBookImageNo = nBookImageNo % 100;

		var bi = "bi-" + bookImageNo;

		return CONST.contentServerUrl + "/websvr/contents/common/smartbookimage/" + d4Str + "/" + d2Str + "/" + bi;
	},
	getSmartBookImageUrl: function (bookImageNo) {
		var bookImagePath = MODULE.Util.getSmartBookImagePath(bookImageNo);
		var bookImageUrl = bookImagePath + "/" + bookImageNo + "-bookimage.png";

		return bookImageUrl;
	},
	getExamPath: function(examKey) {
		var nExamKey = MODULE.Util.number(examKey);

		var d6 = Math.floor(nExamKey / 1000000);
		var d6Str = "d6-" + MODULE.Util.sprintf("%03d", d6);
		nExamKey = nExamKey % 1000000;

		var d4 = Math.floor(nExamKey / 10000);
		var d4Str = "d4-" + MODULE.Util.sprintf("%02d", d4);
		nExamKey = nExamKey % 10000;

		var d2 = Math.floor(nExamKey / 100);
		var d2Str = "d2-" + MODULE.Util.sprintf("%02d", d2);
		nExamKey = nExamKey % 100;

		var ek = "ek-" + examKey;

		return CONST.contentServerUrl + "/websvr/contents/common/exam/" + d6Str + "/" + d4Str + "/" + d2Str + "/" + ek;
	},
	getExamCardImgUrl: function (examKey, examType) {
		var examPath = MODULE.Util.getExamPath(examKey);
		var examCardImgUrl = examPath + "/" + examKey + "-examcard-" + examType + ".png";

		return examCardImgUrl;
	},
	getExamZoomImgUrl: function(examKey, examType) {
		var examPath = MODULE.Util.getExamPath(examKey);
		var examZoomImgUrl = examPath + "/" + examKey + "-exampreview-" + examType + ".png";

		return examZoomImgUrl;
	},
	getExamPreviewImgUrl: function(examKey, examType, zoneType) {
		var examPath = MODULE.Util.getExamPath(examKey);
		var examPreviewImgUrl = "";

		if (zoneType == "qrcode") {
			examPreviewImgUrl = examPath + "/" + examKey + "-preview-qrcode.png";
		} else {
			examPreviewImgUrl = examPath + "/" + examKey + "-preview-" + examType + "-" + zoneType + ".png";
		}

		return examPreviewImgUrl;
	},
	getExamPrintImgUrl: function (examKey, examType, zoneType) {
		var examPath = MODULE.Util.getExamPath(examKey);
		var examPrintImgUrl = "";

		if (zoneType == "qrcode") {
			examPrintImgUrl = examPath + "/" + examKey + "-print-qrcode.png";
		} else {
			examPrintImgUrl = examPath + "/" + examKey + "-print-" + examType + "-" + zoneType + ".png";
		}

		return examPrintImgUrl;
	},
	getExamTextPath: function (examTextKey) {
		var nExamTextKey = MODULE.Util.number(examTextKey);

		var d4 = Math.floor(nExamTextKey / 10000);
		var d4Str = "d4-" + MODULE.Util.sprintf("%02d", d4);
		nExamTextKey = nExamTextKey % 10000;

		var d2 = Math.floor(nExamTextKey / 100);
		var d2Str = "d2-" + MODULE.Util.sprintf("%02d", d2);
		nExamTextKey = nExamTextKey % 100;

		var etk = "etk-" + examTextKey;

		return CONST.contentServerUrl + "/websvr/contents/common/examtext/" + d4Str + "/" + d2Str + "/" + etk;
	},
	getExamTextImgUrl: function (examTextKey) {
		var examTextPath = MODULE.Util.getExamTextPath(examTextKey);
		var examTextImgUrl = examTextPath + "/" + examTextKey + "-examtext.png";

		return examTextImgUrl;
	},
	getProductImagePath: function(productKey) {
		var nProductKey = MODULE.Util.number(productKey);

		var d4 = Math.floor(nProductKey / 10000);
		var d4Str = "d4-" + MODULE.Util.sprintf("%02d", d4);
		nProductKey = nProductKey % 10000;

		var d2 = Math.floor(nProductKey / 100);
		var d2Str = "d2-" + MODULE.Util.sprintf("%02d", d2);
		nProductKey = nProductKey % 100;

		var pk = "pk-" + nProductKey;

		return CONST.contentServerUrl + "/websvr/contents/common/product/" + d4Str + "/" + d2Str + "/" + pk;
	},
	getProductImgUrl: function(productKey) {
		var productImgPath = MODULE.Util.getProductImagePath(productKey);
		var productImgUrl = productImgPath + "/" + productKey + "-product.png";

		return productImgUrl;
	},
	getArrayItemByKeyValue: function(array, key, value) {
		for (var i=0; i<array.length; i++) {
			var obj = array[i];

			if (obj[key] != undefined) {
				if (obj[key] == value) {
					return obj;
				}
			}
		}
		
		return undefined;
	},
	getArrayDeepCopy: function(array, oldItemFunc, newItemFunc) {
		var newArray = [];

		for (var i = 0; i < array.length; i++) {
			var item = array[i];
			
			if (oldItemFunc != undefined) {
				oldItemFunc(i, item);
			}

			var newItem = jQuery.extend({}, item);

			if (newItemFunc != undefined) {
				newItemFunc(i, newItem);
			}

			newArray.push(newItem);
		}

		return newArray;
	},
	getArrayIndexByValue: function(array, value) {
		for (var i = 0; i < array.length; i++) {
			var _value = array[i];

			if (_value != undefined) {
				if (_value == value) {
					return i;
				}
			}
		}

		return undefined;
	},
	getArrayIndexByKeyValue: function(array, key, value) {
		for (var i=0; i<array.length; i++) {
			var obj = array[i];

			if (obj[key] != undefined) {
				if (obj[key] == value) {
					return i;
				}
			}
		}
		
		return undefined;
	},
	number: function(value) {
		var n = parseInt(value);
		return isNaN(n) ? 0 : n;
	},
	getD32CharArray: function() {
		var charArray = [
			"2", "3", "4", "5", "6", "7", "8", "9",
			"A", "B", "C", "D", "E", "F", "G", "H",
			"J", "K", "L", "M", "N", "P", "Q", "R",
			"S", "T", "U", "V", "W", "X", "Y", "Z"
		];

		return charArray;
	},
	d10Tod32: function(d10) {
		var result = "";
		var charArray = MODULE.Util.getD32CharArray();
		var calcNo = MODULE.Util.number(d10);
		var index = 0;
		while (calcNo > 0) {
			index = calcNo % 32;
			calcNo = Math.floor(calcNo / 32);
			
			result = charArray[index] + result;
		}

		return result;
	},
	d32Tod10: function(d32) {
		var result = 0;
		var charArray = MODULE.Util.getD32CharArray();
		var calcNo = 0;

		var upperD32 = d32.toUpperCase();

		for (var i = 0; i < upperD32.length; i++) {
			var char = upperD32.charAt(i);

			var foundIndex = -1;
			for (var j=0; j<charArray.length; j++) {
				if (char == charArray[j]) {
					foundIndex = j;
					break;
				}
			}

			if (foundIndex == -1) {
				throw new Error("invalid d32 character !");
			}

			var value = foundIndex;
			calcNo = (calcNo * 32) + value;
		}

		result = Number(calcNo);

		return result;
	},
	float: function(value) {
		var n = parseFloat(value);
		return isNaN(n) ? 0 : n;
	},
	getTotalDiffId: function (diffExamCountArray) {
		var d1ExamCount = diffExamCountArray[0];
		var d2ExamCount = diffExamCountArray[1];
		var d3ExamCount = diffExamCountArray[2];
		var d4ExamCount = diffExamCountArray[3];
		var totalExamCount =
			d1ExamCount + d2ExamCount + d3ExamCount + d4ExamCount;

		if (totalExamCount == 0) {
			totalExamCount = 1;
		}

		var ratio =
			(
				(d1ExamCount * 4) + (d2ExamCount * 3) +
				(d3ExamCount * 2) + (d4ExamCount * 1)
			) / totalExamCount;

		for (var id in CONST.totalDiff) {
			var item = CONST.totalDiff[id];

			if (ratio >= item.ratio) {
				return item.id;
			}
		}

		return "-";
	},
	getTotalDiffName: function (diffExamCountArray) {
		var _this = this;

		var id = _this.getTotalDiffId(diffExamCountArray);
		
		return CONST.totalDiff[id].name;
	},
	compactAnswerForCheckCorrect: function (answer) {
		var resultAnswer = answer;

		if (resultAnswer == undefined) {
			return "";
		}

		resultAnswer = jQuery.trim(resultAnswer);
		resultAnswer = resultAnswer.replace(/\s/g, '');
		resultAnswer = resultAnswer.replace(/,/g, '');
		resultAnswer = resultAnswer.replace(/랑/g, '');
		resultAnswer = resultAnswer.replace(/와/g, '');
		resultAnswer = resultAnswer.replace(/과/g, '');
		resultAnswer = resultAnswer.replace(/또는/g, '');
		resultAnswer = resultAnswer.replace(/이거나/g, '');
		resultAnswer = resultAnswer.replace(/이고/g, '');
		resultAnswer = resultAnswer.replace(/그리고/g, '');
		resultAnswer = resultAnswer.replace(/이면서/g, '');

		resultAnswer = resultAnswer.replace(/\\cdot/g, '');
		resultAnswer = resultAnswer.replace(/\\mleft\./g, '');
		resultAnswer = resultAnswer.replace(/\\mright\./g, '');
		resultAnswer = resultAnswer.replace(/\\mleft\?/g, '');
		resultAnswer = resultAnswer.replace(/\\mright\?/g, '');
		resultAnswer = resultAnswer.replace(/\\left\./g, '');
		resultAnswer = resultAnswer.replace(/\\right\./g, '');
		resultAnswer = resultAnswer.replace(/\\left\?/g, '');
		resultAnswer = resultAnswer.replace(/\\right\?/g, '');
		resultAnswer = resultAnswer.replace(/{/g, '');
		resultAnswer = resultAnswer.replace(/}/g, '');
		resultAnswer = resultAnswer.replace(/\(/g, '');
		resultAnswer = resultAnswer.replace(/\)/g, '');


		return resultAnswer;
	},
	checkValidateAnswers: function (answers) {
		var result = undefined;

		var inputAnswers = [];

		for (var i = 0; i < answers.length; i++) {
			var answerItem = answers[i];

			if (answerItem.answerType == "obj") {
				if (MODULE.Util.isEmpty(answerItem.inputAnswer)) {
					if (result == undefined) {
						result = {
							code: "EMPTY-ANSWER",
							examNo: (i + 1),
							subExamIndex: -1,
							answerInputIndex: -1
						};
					}

					inputAnswers.push("");
				} else {
					inputAnswers.push(answerItem.inputAnswer);
				}
			} else if (answerItem.answerType == "sbj") {
				var subExamAnswers = [];

				for (var j = 0; j < answerItem.subExamList.length; j++) {
					var subExamItem = answerItem.subExamList[j];

					var answerInputAnswers = [];

					for (var k = 0; k < subExamItem.answerInputList.length; k++) {
						var answerInputItem = subExamItem.answerInputList[k];

						if (
							answerInputItem.answerType == "s-obj" ||
							answerInputItem.answerType == "s-sbj" ||
							answerInputItem.answerType == "s-sel" ||
							answerInputItem.answerType == "s-mat"
						) {
							var inputAnswer = MODULE.Util.compactAnswerForCheckCorrect(answerInputItem.inputAnswer);
							if (MODULE.Util.isEmpty(inputAnswer)) {
								if (result == undefined) {
									result = {
										code: "EMPTY-ANSWER",
										examNo: (i + 1),
										subExamIndex: j,
										answerInputIndex: k
									};
								}

								answerInputAnswers.push("");
							} else {
								answerInputAnswers.push(inputAnswer);
							}
						} else if (answerInputItem.answerType == "s-form") {
							var inputAnswerList = answerInputItem.inputAnswerList;
							var arrayInputAnswer = [];
							for (var l = 0; l < inputAnswerList.length; l++) {
								var inputAnswer = MODULE.Util.compactAnswerForCheckCorrect(inputAnswerList[l]);
								if (MODULE.Util.isEmpty(inputAnswer)) {
									if (result == undefined) {
										result = {
											code: "EMPTY-ANSWER",
											examNo: (i + 1),
											subExamIndex: j,
											answerInputIndex: k
										};
									}

									arrayInputAnswer.push("");
								} else {
									arrayInputAnswer.push(inputAnswer);
								}
							}

							answerInputAnswers.push(arrayInputAnswer);
						}
					}

					subExamAnswers.push(answerInputAnswers);
				}

				inputAnswers.push(subExamAnswers);
			} else if (answerItem.answerType == "des") {

			}
		}

		if (result != undefined) {
			return result;
		}

		return { code: "OK", inputAnswers: inputAnswers };
	},
	checkPassWordReg: function (va) {
		var type1_count = 0;
		var type2_count = 0;
		var type3_count = 0;
		var type4_count = 0;
		var count = 0;

		if (va != "") {

			for (var i = 0; i <= va.length - 1; i++) {
				if ('a' <= va.charAt(i) && va.charAt(i) <= 'z') {
					type1_count++;
				}
				else if ('A' <= va.charAt(i) && va.charAt(i) <= 'Z') {
					type2_count++;
				}
				else if (va.charAt(i) >= '0' && va.charAt(i) <= '9') {
					type3_count++;
				}
				else {
					type4_count++;
				}
			}

			if (type1_count > 0) count++;
			if (type2_count > 0) count++;
			if (type3_count > 0) count++;
			if (type4_count > 0) count++;

		}

		return count;

	},
	isValidEmail: function (va) {
		var filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;

		if (filter.test(va)) {
			return true;
		}

		return false;
	},
	isValidMobile: function(va){
		var filter = /^\d{3}-\d{3,4}-\d{4}$/;

		if (filter.test(va)) {
			return true;
		}

		return false;
	},
	autoHypenMobile: function(va){
		var mobileNO = va.replace(/[^0-9]/g, '');
		var temp = "";

		if (mobileNO.length < 4) {
			return mobileNO;
		} else if (mobileNO.length < 7) {
			temp += mobileNO.substr(0, 3);
			temp += '-';
			temp += mobileNO.substr(3);			
			mobileNO = temp;
		} else if (mobileNO.length < 11) {
			temp += mobileNO.substr(0, 3);
			temp += '-';
			temp += mobileNO.substr(3, 3);
			temp += '-';
			temp += mobileNO.substr(6);			
			mobileNO = temp;
		} else {
			temp += mobileNO.substr(0, 3);
			temp += '-';
			temp += mobileNO.substr(3, 4);
			temp += '-';
			temp += mobileNO.substr(7);			
			mobileNO = temp;
		}

		return mobileNO;

	},
	autoMakeComma: function(va) {

		try {
			var num = va.toString();
			num = num.replace(/\B(?=(\d{3})+(?!\d))/g, ",");	
		}catch(e) {
			num = 0;
		}
		
		return num;
	},
	isMobileBrowser: function() {
		var check = false;
		var UserAgent = navigator.userAgent;
		if (UserAgent.match(/iPhone|iPod|Android|Windows CE|BlackBerry|Symbian|Windows Phone/i) != null 
				|| UserAgent.match(/webOS|Opera Mini|Opera Mobi|POLARIS|IEMobile|lgtelecom|nokia|SonyEricsson/i) != null 		
				|| UserAgent.match(/LG|SAMSUNG|Samsung/) != null) {
					check = true;
		}

		return check;	
	}

	

};

MODULE.DialogBox = {
  infoToast: function(_message, _during) {
    var message = _message || "[MESSAGE EMPTY]";
    var during = _during || 5000;

    var toastTop = f7.toast.create({
      text: message,
      position: "top",
      closeTimeout: during
    });

    toastTop.open();
  },
  warnToast: function(_message, _during) {
    let _this = this;

    _this.infoToast(_message, _during);
  },
  dialog: function(p_title, p_message, p_buttons) {
		let buttons = [];
		if (p_buttons != undefined) {
			buttons = p_buttons;
		}

    f7.dialog.create({
			title: p_title,
			text: p_message,
			buttons: buttons,
			on: {
				open: function() {
					// $(".dialog-inner").removeClass("dialog-inner");
					// $(".dialog-inner-custom").addClass("dialog-inner");
				}
			}
		})
		.open();
	},
	message: function(p_title, p_message, p_fnOk) {
		let _this = this;

		let buttons = [
			{
				text: '확인',
				onClick: function (dialogRef, e) {
					dialogRef.close();

					if (p_fnOk != undefined) {
						p_fnOk(dialogRef);
					}
				}
			}
		];

		_this.dialog(p_title, p_message, buttons);
	},
	okcancel: function(p_title, p_message, p_onokcallback, p_oncancelcallback) {
		let buttons = [
			{
				text: '확인',
				onClick: function (dialogRef) {
					if (p_onokcallback != undefined) {
						p_onokcallback();
					}
					dialogRef.close();
				}
			},
			{
				text: '취소',
				onClick: function (dialogRef) {
					if (p_oncancelcallback != undefined) {
						p_oncancelcallback();
					}
					dialogRef.close();
				}
			}
		];

		this.dialog(p_title, p_message, buttons);
	},
	timerDialog: function (p_title, p_message, p_onokcallback, p_oncancelcallback, second){
		
		let buttons = [
			{
				text: '학습하기',
				onClick: function (dialogRef) {
					if (p_onokcallback != undefined) {
						p_onokcallback();
					}
					dialogRef.close();
				}
			},
			{
				text: '취소',
				onClick: function (dialogRef) {
					if (p_oncancelcallback != undefined) {
						p_oncancelcallback();
					}
					dialogRef.close();
				}
			}
		];

		var _second = second;

		if (_second == null) {
			_second = 10;
		}
		

		var dialog = f7.dialog.create({
			title: p_title,	
			text: p_message + "("+ _second + "초)",
			buttons: buttons,
			on: {
				open: function () {
				
				}
			}
		});			
		
		var intervel = setInterval(function () {
			_second -= 1;
			dialog.setText(p_message + "("+ _second +"초)");
			if (_second === 0) {
				clearInterval(intervel);
				p_oncancelcallback();
				dialog.close();
			}
		}, 1000);
	
		dialog.open();	


	}
};

MODULE.UITool = {

	/*
	beforeFunction = function(code, PAGES, AUTH) {
		if (code == ???) {
			return CONST.CONTINUE_CATCH;	// catchBlock 마저 실행
		} else if (code == ???) {
			return CONST.COMPLETE_CATCH;	// catchBlock 종료.
		}
	}

	afterFunction = function(code, PAGES, AUTH) {
		if (code == ???) {
			return CONST.CONTINUE_CATCH;	// catchBlock 마저 실행
		} else if (code == ???) {
			return CONST.COMPLETE_CATCH;	// catchBlock 종료.
		}
	}
	*/

	catchBlock(code, PAGES, AUTH, beforeFunction, afterFunction) {
		if (beforeFunction != undefined) {
			var bfResult = beforeFunction(code, PAGES, AUTH);
			if (bfResult == CONST.COMPLETE_CATCH) {
				// beforeFunction이 지정되어있고, CONST.COMPLETE_CATCH를 return 한다면,
				// 아래의 catchBlock은 실행되지 않는다.
				return CONST.COMPLETE_CATCH;
			}
		}

		if (code == CONST.resultCode.FORBIDDEN) {

			MODULE.DialogBox.okcancel("에러", "서버 접근이 거부되었습니다.<br/>다시 로그인 할까요 ?",
				function () {  // on OK
					AUTH.removeUserInfo();
					AUTH.removeAccessToken();

					setTimeout(function () {
						PAGES.login();
					}, 500);
				}
			);

		} else if (code == CONST.resultCode.USER_AUTH_EXPIRED) {

			AUTH.removeUserInfo();
			AUTH.removeAccessToken();
			MODULE.DialogBox.message("에러", "사용자 사용권 기간이 만료되었습니다.<br/>사용권 결제후 이용하세요.");
			setTimeout(function () {
				PAGES.login({ forceCode: code });
			}, 500);

		} else if (code == CONST.resultCode.COMPANY_AUTH_EXPIRED) {

			AUTH.removeUserInfo();
			AUTH.removeAccessToken();
			MODULE.DialogBox.message("에러", "고객사 사용권 기간이 만료되었습니다.<br/>선생님께 문의하세요.");
			setTimeout(function () {
				PAGES.login({ forceCode: code });
			}, 500);

		} else if (code == CONST.resultCode.TOKEN_MISMATCH) {

			AUTH.removeUserInfo();
			AUTH.removeAccessToken();

			setTimeout(function () {
				PAGES.login({ forceCode: code });
			}, 500);

		} else if (code == CONST.resultCode.TOKEN_EXPIRED) {
			
			AUTH.removeUserInfo();
			AUTH.removeAccessToken();

			setTimeout(function () {
				PAGES.login();	// none message
			}, 500);

		} else {
			MODULE.DialogBox.message("에러", "요청 처리중 에러가 발생했습니다.<br/>에러코드 : " + code);
		}

		if (afterFunction != undefined) {
			var bfResult = afterFunction(code, PAGES, AUTH);
			if (bfResult == CONST.COMPLETE_CATCH) {
				// afterFunction 지정되어있고, CONST.COMPLETE_CATCH를 return 한다면,
				// 아래의 catchBlock은 실행되지 않는다.
				return CONST.COMPLETE_CATCH;
			}
		}

		return CONST.COMPLETE_CATCH;
	},
	openHintDialog(lectureCode) {
		var hintImageUrl = MODULE.UITool.lectureContentsUrl(lectureCode, "-hint.png");

		var photoBrowserPopup = f7.photoBrowser.create({
			photos: [
				{
					url: hintImageUrl,
					caption: "CODE : " + lectureCode
				}
			],
			theme: "dark",
			type: "popup",
			exposition: false,
			toolbar: false,
			popupCloseLinkText: "닫기"
		});

		photoBrowserPopup.open();
	},
	openMP4Dialog(lectureCode) {
		var mp4Url = MODULE.UITool.lectureContentsUrl(lectureCode, "-lecture.mp4");
		mp4Url = "http://vod.studyq.net/contents/vod/sample/1173108.mp4";

		var html = "<iframe src='" + mp4Url + "' frameborder='0' allowfullscreen></iframe>";
		//var html = "<iframe src='https://www.youtube.com/embed/y1FLCzCM738' frameborder='0' allowfullscreen></iframe>";

		html =
			'<video id="videoplayer" oncontextmenu="return false;" class="video-js vjs-default-skin vjs-fill" controls preload="auto" autoplay="play" disablePictureInPicture controlsList="nodownload">' +
			'<source src="' + mp4Url + '" type="video/mp4"></source>' +
			'</video>';

		var photoBrowserPopup = f7.photoBrowser.create({
			photos: [
				{
					html: html,
					caption: "CODE : " + lectureCode
				}
			],
			theme: "dark",
			type: "popup",
			exposition: false,
			toolbar: false,
			swipeToClose: false,
			popupCloseLinkText: "닫기"
		});

		/* fullscreen이 사용자 액션으로만 정상 동작하므로 사용하지 않는다.
		photoBrowserPopup.on("opened", function() {
			var player = videojs('videoplayer');
			player.on('fullscreenchange', e => {
				const screen = window.screen;
				screen.lockOrientationUniversal('landscape');
			});
			
			if (player.requestFullscreen) {
				player.requestFullscreen();
			} else if (player.mozRequestFullScreen) {
				player.mozRequestFullScreen();
			} else if (player.webkitRequestFullscreen) {
				player.webkitRequestFullscreen();
			}
		});
		*/

		photoBrowserPopup.open();
	},

	lectureContentsUrl(lectureCode, postfix) {
		var subPath = MODULE.Util.codeToSubPath("L", lectureCode, "lk-");
		var fileName = MODULE.Util.codeToFileName("L", lectureCode, postfix);

		var url =
      CONST.contentServerUrl +
      "/" +
      CONST.contentRoot +
      "/" +
			CONST.lectureContentRoot +
			"/" +
			subPath + "/" + fileName;

		return url;
	},
  asyncRun: function(func, delay) {
    var def = jQuery.Deferred();
    var _delay = 0;
    if (delay != undefined) {
      _delay = delay;
    }

    setTimeout(function() {
      func();

      return def.resolve();
    }, _delay);

    return def.promise();
  },
  saveCaretPosition: function(element) {
    element.focus();

    var saveCaretClassName = "caret-pos-save-span";
    var caretSpan = element.find("." + saveCaretClassName);
    if (caretSpan.length > 0) {
      caretSpan.remove();
    }

    var caretSpan = $("<span></span>");
    caretSpan.addClass(saveCaretClassName);

    var sel = window.getSelection && window.getSelection();
    if (sel && sel.rangeCount > 0) {
      var range = sel.getRangeAt(0);
      range.insertNode(caretSpan[0]);
    }

    element.blur();
  },
  restoreCaretPosition: function(element) {
    var saveCaretClassName = "caret-pos-save-span";
    var caretSpan = element.find("." + saveCaretClassName);

    if (caretSpan.length == 0) {
      return;
    }

    element.focus();

    var range = document.createRange();
    range.selectNode(caretSpan[0]);
    var selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    range.deleteContents();
  },
  convertEquationHTML: function(html) {
    var eqReplacer = function(match) {
      var html = MathLive.latexToMarkup(match, "textstyle", "html");
      return html;
    };

    html = html.replace(/\$\$.+\$\$/g, eqReplacer);

    // 스페이스 유니코드 특수문자 0x3000 공백 문자를 사용하였음.
    html = html.replace(
      /##FORM-BOX##/g,
      '<span class="form-box" contenteditable="false">　</span>'
    );

    return html;
  },
  recursiveGetTextContents: function(targetNode) {
    var __wholeTextContent = "";

    var childNodes = targetNode.childNodes;
    for (var i = 0; i < childNodes.length; i++) {
      var node = childNodes[i];
      var nodeName = node.nodeName.toUpperCase();
      var textContent = "";

      if (node.nodeName == "SPAN") {
        var element = $(node);
        if (element.is("[data-original-content]")) {
          textContent = "$$" + element.data("original-content") + "$$";
        } else if (element.is(".ui-form-box")) {
          textContent = "##FORM-BOX##";
        } else {
          if (node.childNodes.length > 0) {
            textContent = MODULE.UITool.recursiveGetTextContents(node);
          } else {
            textContent = node.textContent;
          }
        }
      } else if (node.nodeName == "DIV") {
        var element = $(node);
        if (node.childNodes.length > 0) {
          if (i > 0) {
            textContent = "<br/>";
          }

          textContent += MODULE.UITool.recursiveGetTextContents(node);
        } else {
          if (i > 0) {
            textContent = "<br/>";
          }

          textContent += node.textContent;
        }
      } else {
        textContent = node.textContent;
      }

      __wholeTextContent += textContent;
    }

    __wholeTextContent = jQuery.trim(__wholeTextContent);
    __wholeTextContent = __wholeTextContent.replace(
      /[ \f\t\v\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]/g,
      " "
    );
    __wholeTextContent = __wholeTextContent.replace(/  +/g, " ");
    __wholeTextContent = __wholeTextContent.replace(/\r/g, "\n");
    __wholeTextContent = __wholeTextContent.replace(/\n\n+/g, "\n");
    __wholeTextContent = __wholeTextContent.replace(/\n/g, "<br/>");
    __wholeTextContent = __wholeTextContent.replace(
      /{{\\fontfamily{ams}\\Box }}/g,
      "{\\Box}"
    );
    __wholeTextContent = __wholeTextContent.replace(/^(<br\/>)+/g, "");
    __wholeTextContent = __wholeTextContent.replace(/(<br\/>)+$/g, "");

    return __wholeTextContent;
  }
};

export default MODULE;
